document.querySelectorAll('.vdo-btn-click').forEach(function(button) {
  button.addEventListener('click', function() {
    let thumbWrap = this.closest('.thumb-btn-wrap');
    let video = thumbWrap.closest('.video-sec').querySelector('#vdo-play');
    
    if (video) {
      video.muted = true; 
      video.play().catch(err => console.warn("Playback blocked:", err));
      
      thumbWrap.style.display = 'none';

      video.addEventListener('pause', function() {
        thumbWrap.style.display = 'flex';
      });

      video.addEventListener('ended', function() {
        thumbWrap.style.display = 'flex';
      });
    }
  });
});


function updateMuteButton(button, video) {
  const mutedIcon = button.querySelector('.icon-muted');
  const unmutedIcon = button.querySelector('.icon-unmuted');

  if (video.muted) {
    mutedIcon.style.display = '';
    unmutedIcon.style.display = 'none';
    button.setAttribute('aria-label', 'Unmute video');
    button.setAttribute('aria-pressed', 'false');
  } else {
    mutedIcon.style.display = 'none';
    unmutedIcon.style.display = '';
    button.setAttribute('aria-label', 'Mute video');
    button.setAttribute('aria-pressed', 'true');
  }
}

// Initialize all existing buttons
document.querySelectorAll('.video-mute-toggle').forEach((button) => {
  const wrap = button.closest('.vdo-wrap');
  const video = wrap?.querySelector('#vdo-play');

  if (video) {
    updateMuteButton(button, video);
  }
});

// Event delegation
document.addEventListener('click', (e) => {
  const button = e.target.closest('.video-mute-toggle');

  if (!button) return;

  const wrap = button.closest('.vdo-wrap');
  const video = wrap?.querySelector('#vdo-play');

  if (!video) return;

  video.muted = !video.muted;
  updateMuteButton(button, video);
});


(async function () {
  console.log('hiii');

  const overlay = document.getElementById('contestOverlay');
  const overlayContent = document.getElementById('contestOverlayContent');
  const closeBtn = document.querySelector('.contest-close');

  if (!overlay || !overlayContent) return;

  try {
    const response = await fetch('/pages/content');

    if (!response.ok) {
      throw new Error('Unable to load contest page');
    }

    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const pageContent = doc.querySelector('#MainContent');

    console.log(doc);
    console.log(pageContent);

    if (pageContent) {
      overlayContent.innerHTML = pageContent.innerHTML;

      overlay.classList.remove('hidden');
      overlay.classList.add('active');

      document.body.classList.add('overlay-open');
    } else {
      console.error('MainContent not found');
    }
  } catch (error) {
    console.error(error);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      overlay.classList.remove('active');
      overlay.classList.add('hidden');
      document.body.classList.remove('overlay-open');
    });
  }
})();